module.exports = __webpack_public_path__ + "static/img/6-nei.49c5e2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/6-nei.png
// module id = uhSD
// module chunks = 1